import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { DynamicSQLGridComponent } from './components/admin-components/admin-grids/dynamic-sql-grid/dynamic-sql-grid.component';
import { AuthGuard } from './auth-guard/auth.guard';
import { DashboardRedirectGuard } from './auth-guard/dashboard-redirect-guard';
import { ViewGridComponent } from './components/admin-components/admin-grids/viewgrid/viewgrid.component';
import { LoginComponent } from './components/login/login.component';
import { QBIntercompanyComponent } from './components/admin-components/admin-grids/qb-intercompany/qb-intercompany.component';
import { HourglassComponent } from './components/admin-components/hourglass/hourglass.component';
import { AppInfoComponent } from './components/app-info/app-info.component';
import { PlaidComponent } from './components/admin-components/tools/plaid/plaid.component';
import { WelaraAcademyComponent } from './components/user-components/welara-academy/welara-academy.component';
import { MinutesComponent } from './components/admin-components/minutes/minutes.component';
import { PfsComponent } from './components/client-components/pfs/pfs.component';
import { TeamsComponent } from './components/admin-components/hourglass/teams/teams.component';
import { BillingReviewPivotGridComponent } from './components/admin-components/billing-review-pivot-grid/billing-review-pivot-grid.component';
import { TabTaskManagerComponent } from './components/admin-components/hourglass/tab-task-manager/tab-task-manager.component';
import { TabBillingReviewGridComponent } from './components/admin-components/hourglass/tab-billing-review-grid/tab-billing-review-grid.component';
/*import { ClientDashboardComponent } from './components/client-components/client-dashboard/client-dashboard.component';*/
import { UserDashboardComponent } from './components/user-components/user-dashboard/user-dashboard.component';
/*import { AdminDashboardComponent } from './components/admin-components/admin-dashboard/admin-dashboard.component';*/
import { ExcelUploadComponent } from './components/admin-components/excel-upload-component/excel-upload.component';
import { ClientFilesComponent } from './components/client-components/client-files/client-files.component';
import { BillingComponent } from './components/admin-components/billing/billing.component';
import { BillingGeneratorComponent } from './components/admin-components/billing-generator/billing-generator.component';
import { BillingQbRefreshComponent } from './components/admin-components/billing-qb-refresh/billing-qb-refresh.component';
import { BillingConfigurationComponent } from './components/admin-components/billing-configuration/billing-configuration.component';
import { TaxLotsComponent } from './components/admin-components/tools/tax-lots/tax-lots.component';
import { TokenUxComponent } from './components/admin-components/tools/token-ux/token-ux.component';
import { DynamicSqlColumnAdderComponent } from './dynamic-sql-column-adder/dynamic-sql-column-adder.component';
import { GoogleDriveAccessComponent } from './components/user-components/google-drive-access/google-drive-access.component';
import { BtcPriceTrackerComponent } from './components/user-components/btc-price-tracker/btc-price-tracker.component';
import { TradingDashboardComponent } from './components/user-components/trading-dashboard/trading-dashboard.component';
import { UsersComponent } from './components/admin-components/tools/users/users.component';
import { SecureMessagingComponent } from './components/client-components/smc/smc.component';
import { LoginEmailComponent } from './components/login/email/login-email.component';
import { LoginKeyComponent } from './components/login/key/login-key.component';
import { RegisterYubikeyComponent } from './components/client-components/yubi/register_yubi.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  { path: 'login/email/:remember', component: LoginEmailComponent },
  { path: 'login/otp', component: LoginKeyComponent },
  {
    path: '', component: LayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', redirectTo: 'user-dashboard' },
      { path: 'user-dashboard', component: UserDashboardComponent },
      { path: 'dynamicsqlgrid/:table', component: DynamicSQLGridComponent },
      { path: 'dataviews/:view', component: ViewGridComponent },
      { path: 'qbintercompany', component: QBIntercompanyComponent },
      { path: 'hourglass', component: HourglassComponent },
      { path: 'hourglass/:tab', component: HourglassComponent },
      { path: 'appinfo', component: AppInfoComponent },
      { path: 'plaid', component: PlaidComponent },
      { path: 'academy', component: WelaraAcademyComponent },
      { path: 'minutes', component: MinutesComponent },
      
      { path: 'teams', component: TeamsComponent },
      { path: 'taskcombine', component: TabTaskManagerComponent },
      { path: 'billingreview', component: TabBillingReviewGridComponent },
      { path: 'pfs', component: PfsComponent },
      { path: 'excel-upload', component: ExcelUploadComponent },
      { path: 'client-files', component: ClientFilesComponent },
      { path: 'admin/billing', component: BillingComponent },
      { path: 'admin/billing-generator', component: BillingGeneratorComponent },
      { path: 'admin/billing-configuration', component: BillingConfigurationComponent },
      { path: 'admin/billing-qb-sync', component: BillingQbRefreshComponent },
      { path: 'admin/billing-review-pivot-grid', component: BillingReviewPivotGridComponent },
      { path: 'tools/tax-lots', component: TaxLotsComponent },
      { path: 'tools/token-ux', component: TokenUxComponent },
      { path: 'tools/users', component: UsersComponent },
      { path: 'admin/dynamicsqladder', component: DynamicSqlColumnAdderComponent },
      { path: 'googledriveaccess', component: GoogleDriveAccessComponent },
      { path: 'btcprice', component: BtcPriceTrackerComponent },
      { path: 'trading-dashboard', component: TradingDashboardComponent },
      { path: 'smc', component: SecureMessagingComponent },
      { path: 'passkey', component: RegisterYubikeyComponent }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
